import { useTheme } from '../context/ThemeContext';
import './ThemeSwitcher.css';

export function ThemeSwitcher() {
  const { theme, setTheme, availableThemes } = useTheme();

  return (
    <div className="theme-switcher">
      <h3 className="theme-switcher-title">Theme</h3>
      <div className="theme-options">
        {availableThemes.map((t) => (
          <button
            key={t.id}
            className={`theme-option ${theme === t.id ? 'active' : ''}`}
            onClick={() => setTheme(t.id)}
          >
            <div className={`theme-preview theme-preview-${t.id}`} />
            <div className="theme-info">
              <span className="theme-name">{t.name}</span>
              <span className="theme-description">{t.description}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
